export default {
  newRecipe: 'Nowy przepis',
  protectedTooltip: 'Tego przepisu nie można zmienić, ponieważ jest chroniony',
};
